import type { CurationSnapDetailItem, CurationSnapItem } from '@musinsa/services-curator';
import type { SnapCurationListItem } from './type';

export function snapItemFromCurationDetail(item: CurationSnapItem): SnapCurationListItem {
  return {
    id: String(item.id),
    imageUrl: item.imageUrl,
    linkUrl: item.linkUrl,
  };
}

export function snapItemFromSnapDetailApi(item: CurationSnapDetailItem): SnapCurationListItem {
  const imageUrl = item.imageUrls[0] ?? '';
  return {
    id: String(item.id),
    imageUrl,
    linkUrl: item.linkUrl,
  };
}
